export default "__VITE_ASSET__CX5ZF3jm__"